<template>
    <md-card>
        <md-card-header class="md-card-header-icon" :class="'md-card-header-' + color.icon">
            <div class="md-layout md-gutter">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fas', icon]" />
                    </div>
                    <h4 class="title">{{ title }}</h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                    <div class="flex items-center justify-end header-actions">
                        <div>
                            <md-button class="md-icon-button md-raised md-info"
                                       @mousedown="goToRoute($event, 'Demand Add')">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'plus-circle']" />
                                <span class="leading-none font-medium ml-2">Ajouter une demande</span>
                            </md-button>
                        </div>
                    </div>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
            <template v-if="search">
                <div>
                    <span class="font-bold">Recherche personnalisée</span>
                </div>
                <form @submit.prevent="getDemands">
                    <div class="flex items-center mb-2">
                        <div class="mr-4" style="min-width: 350px;">
                            <md-field>
                                <label>Recherche</label>
                                <md-input v-model="customSearch" name="customSearch" type="text"></md-input>
                                <span class="md-helper-text">Recherche effectuée sur le prospect, le sujet et le message</span>
                            </md-field>
                        </div>
                        <md-button class="md-default md-dense" @click="getDemands">Rechercher</md-button>
                    </div>
                </form>
            </template>
            <md-table class="paginated-table" v-if="(search && demands.length > 0) || (!search)"
                      :table-header-color="color.table"
                      :value="demands"
            >
                <md-table-toolbar>
                    <md-field>
                        <label for="pages">Éléments à afficher</label>
                        <md-select v-model="pagination.perPage" name="pages">
                            <md-option
                                v-for="item in pagination.perPageOptions"
                                :key="item" :label="item" :value="item">
                                {{ item }}
                            </md-option>
                        </md-select>
                    </md-field>

                    <md-field>
                        <md-input
                            type="search"
                            clearable
                            style="width: 250px"
                            placeholder="Rechercher..."
                            v-model="searchQuery"
                        >
                        </md-input>
                    </md-field>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="#" style="max-width: 50px; width: 50px;">
                        {{ item.id }}
                    </md-table-cell>
                    <md-table-cell md-label="Créateur">
                        <div class="flex items-center">
                            <div class="creator-cube" :style="{ backgroundColor: item.creator.color && item.creator.color.includes('#') && item.creator.color.length === 7 ? item.creator.color : '#000000' }"></div>
                            <span class="ml-2 leading-none">{{ item.creator.first_name }}</span>
                        </div>
                    </md-table-cell>
                    <md-table-cell md-label="Date de la demande">
                        {{ $moment(item.date).format('DD/MM/YYYY HH:mm') }}
                    </md-table-cell>
                    <md-table-cell md-label="Dernières infos">
                        {{ item.last_infos ? $moment(item.last_infos).format('DD/MM/YYYY HH:mm') : $moment(item.date).format('DD/MM/YYYY HH:mm') }}
                    </md-table-cell>
                    <md-table-cell md-label="Client" style="min-width: 400px;">
                        <span v-if="item.client" class="text-success cursor-pointer uppercase"
                              @mousedown="goToRoute($event, 'Client Details', { id: item.client_id })">
                            {{ item.client.name }}
                        </span>
                        <span v-else class="text-danger uppercase">{{ item.prospect }}</span>
                        <span v-if="item.site" class="uppercase cursor-pointer hover:underline"
                              @mousedown="goToRoute($event, 'Site Details', { id: item.client_id, idSite: item.site_id })">
                            {{' (' + item.site.name + ')' }}
                        </span>
                        <span v-else>{{ ' (aucun site)' }}</span>
                    </md-table-cell>
                    <md-table-cell md-label="" style="max-width: 40px;">
                        <div class="text-center">
                            <div class="button-icon-tooltip">
                                <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-default">
	                                <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                                </md-button>
                                <md-tooltip md-direction="top" style="min-width: 350px !important;">
                                    <div>
                                        <b>Message : </b>
                                        {{ item.message }}
                                    </div>
                                </md-tooltip>
                            </div>
                        </div>
                    </md-table-cell>
                    <md-table-cell md-label="Sujet" style="min-width: 400px;">
                        <span class="text-info cursor-pointer" @mousedown="goToRoute($event, 'Demand Details', { demandId: item.id })">
                            {{ item.subject }}
                        </span>
                    </md-table-cell>
                    <md-table-cell md-label="Actions" style="min-width: 150px;" v-if="action">
                        {{ formatActions(item) }}
                    </md-table-cell>
                    <md-table-cell md-label="" style="max-width: 50px; width: 50px;">
                        <div class="text-center">
                            <md-button class="md-icon-button md-raised md-warning" @mousedown="goToRoute($event, 'Demand Edit', { demandId: item.id })">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                            </md-button>
                            <md-tooltip md-direction="top">Modifier</md-tooltip>
                        </div>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
            <p class="card-category">
                Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
            </p>
            <pagination
                class="pagination-no-border" :class="'pagination-' + color.pagination"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @input="getDemands"
            >
            </pagination>
        </md-card-actions>
    </md-card>
</template>

<script>
import { Pagination } from "@/components";
import routerMixin from '@/mixins/router-mixin';

export default {
    name: "DemandCard",
    components: {
        Pagination
    },
    mixins: [routerMixin],
    props: {
        title: String,
        active: Boolean,
        icon: String,
        color: {
            type: Object,
            default() {
                return {
                    icon: 'blue',
                    table: 'blue',
                    pagination: 'info'
                }
            }
        },
        payload: {
            type: Object,
            default() {
                return {
                    status: null,
                    limit: null,
                    client_id: null
                }
            }
        },
        action: Boolean,
        search: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data() {
        return {
            demands: [],
            pagination: {
                perPage: 50,
                currentPage: 1,
                perPageOptions: [50, 100, 150],
                total: 0
            },
            searchQuery: "",
            searchedData: [],
            fuseSearch: null,
            customSearch: ''
        }
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.demands;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.demands.length;
        },
    },
    methods: {
        async getDemands() {
            if((this.search && this.customSearch !== '') || !this.search) {
                const response = await this.$store.dispatch('demands/getDemands', {
                    page: this.pagination.currentPage,
                    perPage: this.pagination.perPage,
                    search: this.searchQuery,
                    status: this.payload.status,
                    limit: this.payload.limit ?? null,
                    client: this.payload.client ?? null,
                    customSearch: this.customSearch ?? null
                })
                this.demands = response.data.data
                this.pagination.total = response.data.total
                if(this.search && this.demands.length === 0) {
                    await this.$store.dispatch('alerts/warning', 'Aucune demande correspondante.')
                }
            } else {
                await this.$store.dispatch('alerts/warning', 'Veuillez remplir le champ de recherche.')
            }
        },
        formatActions(demand) {
            let tasks = demand.tasks ? demand.tasks.filter(task => { return task.is_done === 0 }) : []
            if(tasks.length > 0) {
                return tasks.length + ' action(s) en cours'
            } else {
                return '-'
            }
        }
    },
    mounted() {
        if(this.active && !this.search) {
            this.getDemands()
        }
    },
    watch: {
        active: function(newVal, oldVal) {
            if(newVal && !this.search) {
                this.getDemands()
            }
        },
        searchQuery() {
            this.getDemands()
        }
    }
}
</script>

<style scoped lang="scss">
.creator-cube {
    width: 12px;
    height: 12px;
    border-radius: 3px;
}
</style>
